import { Button, Input, Space, Typography, message } from 'antd';
import type { SchemaGitSettings } from '../../storage/schemaGitSettings';
import './SchemaGitConnectionForm.css';

const { Text } = Typography;

export interface SchemaGitConnectionFormProps {
  draft: SchemaGitSettings;
  onDraftChange: (next: SchemaGitSettings) => void;
  onApply: () => void;
  onResetEnvDefaults?: () => void;
  connectionChanged: boolean;
  applying?: boolean;
  compact?: boolean;
}

/** Schema Git 仓库连接：URL + 分支，可覆盖 env 默认值。 */
export function SchemaGitConnectionForm({
  draft,
  onDraftChange,
  onApply,
  onResetEnvDefaults,
  connectionChanged,
  applying = false,
  compact = false,
}: SchemaGitConnectionFormProps) {
  const handleApply = () => {
    if (!draft.repoUrl.trim()) {
      message.error('请填写 Git 仓库 URL');
      return;
    }
    onApply();
  };

  return (
    <div className={`schema-git-connection-form${compact ? ' schema-git-connection-form--compact' : ''}`}>
      {!compact ? (
        <Text type="secondary" className="schema-git-connection-form-label">
          Git 仓库
        </Text>
      ) : null}
      <Space wrap align="start" size="small">
        <Input
          className="schema-git-connection-form-repo"
          size="small"
          placeholder="git@host:org/repo.git"
          value={draft.repoUrl}
          onChange={(e) => onDraftChange({ ...draft, repoUrl: e.target.value })}
          onPressEnter={handleApply}
        />
        <Input
          className="schema-git-connection-form-branch"
          size="small"
          placeholder="分支"
          value={draft.branch}
          onChange={(e) => onDraftChange({ ...draft, branch: e.target.value })}
          onPressEnter={handleApply}
        />
        <Button
          type="primary"
          size="small"
          disabled={!connectionChanged}
          loading={applying}
          onClick={handleApply}
        >
          应用
        </Button>
        {onResetEnvDefaults ? (
          <Button type="link" size="small" onClick={onResetEnvDefaults}>
            恢复默认
          </Button>
        ) : null}
      </Space>
    </div>
  );
}
